import { Chip, Grid, Stack } from "@mui/material";
import PropTypes from "prop-types";

import { toJalaliFullDate } from "../../../middleware/middleware";
import RequestDetailField from "./RequestDetailField";

const RequestSummaryTab = ({ request, titleName, listRow }) => {
  if (!request) return null;

  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12}>
        <Stack direction="row" flexWrap="wrap" sx={{ gap: 0.75 }}>
          {request.leadPriorityTitle ? (
            <Chip
              size="small"
              label={request.leadPriorityTitle}
              sx={
                request.leadPriorityColor
                  ? { bgcolor: request.leadPriorityColor, color: "#fff" }
                  : undefined
              }
            />
          ) : null}
          {request.followUpReminderTitle ? (
            <Chip
              size="small"
              variant="outlined"
              label={request.followUpReminderTitle}
            />
          ) : null}
        </Stack>
      </Grid>
      <RequestDetailField label="متقاضی" value={titleName} sm={4} />
      <RequestDetailField label="موبایل" value={request.mobile} sm={4} />
      <RequestDetailField
        label="کد ملی"
        value={request.nationalCode || request.companyNationalCode}
        sm={4}
      />
      <RequestDetailField
        label="شناسه قبض"
        value={request.electricBoillNumber}
        sm={4}
      />
      <RequestDetailField
        label="استان / شهر"
        value={[request.provinceName, request.cityName].filter(Boolean).join(" — ")}
        sm={4}
      />
      <RequestDetailField
        label="وضعیت درخواست"
        value={request.requestConfirmTitle}
        sm={4}
      />
      <RequestDetailField label="مرحله فعلی" value={request.stepTitle} sm={4} />
      <RequestDetailField
        label="مسئول پیگیری"
        value={
          request.assignedOperatorFullName ||
          listRow?.assignedOperatorDisplay ||
          "بدون مسئول"
        }
        sm={4}
      />
      <RequestDetailField label="امتیاز لید" value={request.leadScore} sm={4} />
      <RequestDetailField
        label="اولویت"
        value={request.leadPriorityTitle}
        sm={4}
      />
      <RequestDetailField
        label="وضعیت یادآور"
        value={request.followUpReminderTitle}
        sm={4}
      />
      <RequestDetailField
        label="آخرین بروزرسانی"
        value={toJalaliFullDate(request.updateOn)}
        sm={4}
      />
      {request.leadScoreReasonSummary ? (
        <RequestDetailField
          label="خلاصه دلیل امتیاز"
          value={request.leadScoreReasonSummary}
          fullWidth
        />
      ) : null}
    </Grid>
  );
};

RequestSummaryTab.propTypes = {
  request: PropTypes.object,
  titleName: PropTypes.string,
  listRow: PropTypes.object,
};

export default RequestSummaryTab;
